module.exports = __webpack_public_path__ + "static/media/shape.9ea9d3d6.svg";